import React, { useEffect } from "react";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getDataFromRoutes, setMetaTags } from "../../utils/util_functions";
import { ROUTES_CONST } from "../../utils/constants";


function Main() {

  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    metaTitle
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);
  useEffect(() => {
    setMetaTags(metaTitle);
    // eslint-disable-next-line
  }, []);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);


  return (
    <main className='main'>
      <div className="mt40">
        <p className="text">
          Контент страницы "Главная"
        </p>
      </div>
    </main>
  );
}

export default Main;
